/**
 * Utility that handles all responses to scroll events
 */
class ScrollManager {
  /**
   * Initializes class
   */
  constructor() {
    this.onScroll = [];
    this.onScrollIn = [];
    this.scroll = this.scroll.bind(this);
    this.throttled = false;

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.scroll);
    }
  }

  /**
   * Adds a function to be fired each time the user scrolls
   * @param {*} func function to add
   */
  addOnScroll(func) {
    this.onScroll.push(func);
  }

  /**
   * Adds a function to be fired when a particular element scrolls in
   * @param {*} func function to add
   * @param {obkect} ref object reference
   */
  addOnScrollIn(func, ref) {
    this.onScrollIn.push({ func, ref });
  }

  /**
   * Scroll Listener
   * @param {object} e event object
   */
  scroll(e) {
    if (this.throttled) return;
    this.throttled = true;
    setTimeout(() => {
      this.onScroll.map(item => item(e));
      this.onScrollIn.map((item) => {
        if (item.ref && item.ref.getBoundingClientRect()) {
          const rect = item.ref.getBoundingClientRect();
          if (item.isVisible && rect.top > 0) {
            return item.hide(e);
          }
          if (!item.isVisible && rect.top < 0) {
            return item.show(e);
          }
        }
        return null;
      });
      this.throttled = false;
    }, 100);
  }
}

export default new ScrollManager();



// WEBPACK FOOTER //
// ./src/utils/scrollManager.js